import React from 'react';
import './Sitemap.css'; // Import the CSS for tree styling

const sitemapData = {
    Home: [],
    'About Us': [],
    Products: {
      'Field Crops': {
        'Rabi Season': ['Wheat', 'Gram', 'Lentil', 'Barley', 'Toria', 'Mustard'],
        'Kharif Season': [
          'Cotton',
          'Guar',
          'Bajra',
          'Paddy',
          'Arhar',
          'Til',
          'Moth',
          'Moong',
          'Urad',
          'Maize',
        ],
      },
      Vegetables: ['Rabi Season', 'Kharif Season', 'Schemes'],
    },

    Production: [
      'Stages of Production',
      'Seed Production',
      'Seed Processing',
      'Incentives / Facilities To Growers',
    ],
    Marketing: [
      'Sale Rate of Rabi Seeds - Crops',
      'Sale Rate of Rabi Seeds - Vegetables',
      'Sale Rate of Kharif Seeds - Crops',
      'Sale Rate of Kharif Seeds - Vegetables',
      'Availability of Rabi Seeds',
      'Availability of Kharif Seeds',
      'Regional Offices',
      'List of Sale Counters',
      'Sale Rate of Agro Chemicals/Pesticides/Weedicides/Insecticides',
      'Details of Citizen Services Delivered by the Organization',
      'Manner of Execution of Subsidy Programme',
      'Allocation of Wheat, Gram, Mustard and Barley Seeds for Sale during Rabi 2022-23 season',
    ],
    Engineering: [],
    Administration: {
      'Services Rules': [],
      Circular: [],
      'Forms & Procedures': [],
      'Purchase Manual': [],
      'Notifications & Orders': [],
      'Placement Announcements': [],
      Policies: [],
      'Transfers & Promotions': [],
      Miscellaneous: [],
      'Anti Stubble Burning Campaign':[],
    },
    'Contact Us': [],
    Tenders: [],
    Finance: [],
    Directory: [
      'Directors',
      'Head Offices',
      'Regional Offices',
    ],
    'RTI Act, 2005': {
      'Application Form':[],
      'Fees':[],
      'List of Authorities':[],
      'RTI Replies':[],
      'Proactive Disclosure': [
      'Particulars of Organization, Functions & Duties',
      'Powers & Duties of its Officer & Employees',
      'Procedure followed in the Decision Making Process',
      'Norms set for discharge of functions',
      'The Rules, Regulations, Instructions, Manuals & Record',
      'Statement of Categories of Documents',
      'The Particulars of any arrangement that exists for consultation with or representation by the member of public in relation to the formulation of its policy or implementation thereof',
      'Statement of the boards, councils, committees & other bodies',
      'A Directory of Officers And Employees',
      'The Monthly Remuneration received by each of its officers and employees',
      'Budget Allotment',
      'The manner of execution of subsidy programme',
      'Particulars of recipients of concessions, permits or authorization granted by it',
      'Details in respect of information available or held by it in electronic form',
      'The Particulars of facilities available to citizens for obtaining information',
      'The Names, Designations & other particulars of Public Information Officers',
      'Such Other Information / FAQs',
    ],
    },
    
    Services: [],
    'Photo Gallery': [],
    'Accessibility Statement': [],
    'Website Policies': ['Copyright Policy', 'Privacy Policy', 'Hyperlink Policy'],
    Feedback: [],
    Disclaimer: [],
    'Terms & Conditions': [],
    Help: [],
    'Internal Complaint Committee': [],
    'Audit Cell': [],
    'Quality Control': [],
    'Grower Agreements': [],
    'CSR Policy': [],
    'Vigil Mechanism Policy': [],
  };
  

const renderSitemap = (data) => {
  if (Array.isArray(data)) {
    return (
      <ul>
        {data.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  } else if (typeof data === 'object') {
    return (
      <ul>
        {Object.entries(data).map(([key, value]) => (
          <li key={key}>
            <span>{key}</span>
            {renderSitemap(value)}
          </li>
        ))}
      </ul>
    );
  }
  return null;
};

const Sitemap = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>HSDC Sitemap </h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg ">

    <div className="sitemap-container">
      <div className="sitemap-tree">
        {renderSitemap(sitemapData)}
      </div>
    </div>
    </div>
    </div>
  );
};

export default Sitemap;
